import * as requestFromServer from "./StudentAbsenteeismReportCrud";
import { callTypes, studentAbsenteeismReportSlice } from "./StudentAbsenteeismReportSlice";

const {actions} = studentAbsenteeismReportSlice;

export const getStudentAbsenteeismReport = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getStudentAbsenteeismReport(queryParams)
    .then(response => {
      dispatch(actions.studentAbsenteeismReportFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllStudentAbsenteeismReport = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllStudentAbsenteeismReport(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getSections = () => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getSections()
    .then(response => {
      dispatch(actions.sectionsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getStudents = (term, sectionId) => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getStudents(term, sectionId)
    .then(response => {
      dispatch(actions.studentsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const cleanStudentsState = () => dispatch => {
  dispatch(actions.studentsStateCleaned());
}

export const cleanStudentAbsenteeismReportState = () => dispatch => {
  dispatch(actions.studentAbsenteeismReportStateCleaned());
}